import { render } from "./SettingsImportComponent.vue?vue&type=template&id=dac39a24&scoped=true"
import script from "./SettingsImportComponent.vue?vue&type=script&lang=js"
export * from "./SettingsImportComponent.vue?vue&type=script&lang=js"

import "./SettingsImportComponent.vue?vue&type=style&index=0&id=dac39a24&lang=scss&scoped=true"
import "./SettingsImportComponent.vue?vue&type=style&index=1&id=dac39a24&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dac39a24"]])

export default __exports__